// Initialize monitoring before anything else
import "@/services/monitoring/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
// CRITICAL: Initialize API client BEFORE importing App.
// React Router v7 fires route loaders immediately when createBrowserRouter()
// is called during router.tsx module evaluation. App.tsx imports router.tsx,
// so the API client must be configured before App is imported. Otherwise,
// protectedLoader sends auth requests without the Authorization header,
// causing 401 errors and redirect loops on every page refresh.
import "@/client/client-config";
import App from "./App";
import "./index.css";
import "@heycircle/ui/fonts/helvetica-neue.css";
// Initialize i18n before React renders
import "@/services/i18n/client";
import { clearChunkReloadFlag } from "@/lib/lazy-with-retry";

// Handle stale chunk errors after deployment.
// Vite fires this event when a preloaded chunk (CSS/JS) fails to load.
// This is a safety net — lazyWithRetry handles most cases, but Vite's
// preload links (injected in HTML) can also fail with stale hashes.
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

// Clear the chunk reload flag on successful app load.
// This prevents the flag from persisting after a successful reload.
clearChunkReloadFlag();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
